import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {LoginService} from '@services/aplicacao-service/login.service';

@Injectable({
    providedIn: 'root'
})
export class UserValidadorGuard implements CanActivateChild {
    constructor(private router: Router, private loginService: LoginService) {
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const usr = this.loginService.getUtilizadorSessao();
        if (usr?.validador && !state.url.includes('/artigos/inscricoes/QRCODE/')) {
            this.router.navigate(['/artigos/inscricoes/QRCODE/0']).finally();
            return false;
        }
        return true;
    }
}
